import {
    FETCH_SUBSCRIBER_EVENT_DETAILS_FETCHING,
    FETCH_SUBSCRIBER_EVENT_DETAILS_SUCCESS,
    FETCH_SUBSCRIBER_EVENT_DETAILS_FAIL,
    FETCH_EVENTS_BY_DATE_SUCCESS,
    FETCH_EVENTS_BY_DATE_ERROR,
    FETCH_EVENTS_BY_DATE_FETCHING,
    RESET_FETCH_EVENTS_BY_DATE,
    ADD_EVENT_TO_DUPLICATE,
    REMOVE_EVENT_TO_DUPLICATE,
    REMOVE_EVENT_TO_EDIT,
    ADD_EVENT_TO_EDIT,
    FETCH_RACE_EVENT_PROVIDERS_SUCCESS,
    FETCH_RACE_EVENT_PROVIDERS_FAIL,
    FETCH_RACE_EVENT_PROVIDERS_FETCHING,
    ADD_TEMPORARY_EVENT,
    REMOVE_TEMPORARY_EVENT,
    RESET_SUBSCRIBER_EVENT_DETAILS
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    eventDetails: {},
    fetching: false,
    error: false,
    success: false,
    events: [],
    eventToCopy: null,
    editEventInfo: null,
    raceEventProviders: {
        providers: [],
        success: false,
        fetching: false,
        error: false
    },
    temporaryEvent: null
};

const subscriberEventDetailsFetching = (state) => {
    return {
        ...state,
        eventDetails: {
            ...state.eventDetails,
            event: null
        },
        fetching: true
    };
};

const subscriberEventDetailsSuccess = (success) => (state, action) => {
    return {
        ...state,
        eventDetails: {
            ...state.eventDetails,
            event: success ? action.event : null,
            success: success,
            error: !success
        },
        fetching: false
    };
};

const fetchEventsByDateFetching = (state) => {
    return {
        ...state,
        error: false,
        success: false,
        fetching: true,
        events: []
    };
};

const fetchEventsByDateSuccess = (success) => (state, action) => {
    return {
        ...state,
        fetching: false,
        error: !success,
        success: success,
        events: success ? action.events : []
    };
};

const resetEventsByDate = (state) => {
    return {
        ...state,
        fetching: false,
        error: false,
        success: false,
        events: []
    };
};

const addEventToDuplicate = (state, action) => {
    return {
        ...state,
        eventToCopy: action.event
    };
};

const removeEventToDuplicate = (state) => {
    return {
        ...state,
        eventToCopy: null
    };
};

const addEventToEdit = (state, action) => {
    return {
        ...state,
        editEventInfo: {
            tab: action.tab,
            date: action.date,
            id: action.id,
            shareableEventUuid: action.shareableEventUuid,
            pageIndex: action.pageIndex,
            sortColumn: action.sortColumn,
            sortOrder: action.sortOrder
        }
    };
};

const removeEventToEdit = (state) => {
    return {
        ...state,
        editEventInfo: null
    };
};

const raceEventProvidersFetching = (state) => {
    return {
        ...state,
        raceEventProviders: {
            ...state.raceEventProviders,
            fetching: true,
            success: false,
            error: false
        }
    };
};

const raceEventProvidersSuccess = (success) => (state, action) => {
    return {
        ...state,
        raceEventProviders: {
            providers: action.providers,
            fetching: false,
            success: success,
            error: !success
        }
    };
};

const addTemporaryEvent = (state, action) => {
    return {
        ...state,
        temporaryEvent: action.event
    };
};

const removeTemporaryEvent = (state) => {
    return {
        ...state,
        temporaryEvent: null
    };
};

const resetSubcriberEventDetails = (state) => {
    return {
        ...state,
        eventDetails: {},
        fetching: false
    };
};

const handlers = {
    [FETCH_SUBSCRIBER_EVENT_DETAILS_FETCHING]: subscriberEventDetailsFetching,
    [FETCH_SUBSCRIBER_EVENT_DETAILS_SUCCESS]: subscriberEventDetailsSuccess(true),
    [FETCH_SUBSCRIBER_EVENT_DETAILS_FAIL]: subscriberEventDetailsSuccess(false),
    [FETCH_EVENTS_BY_DATE_FETCHING]: fetchEventsByDateFetching,
    [FETCH_EVENTS_BY_DATE_SUCCESS]: fetchEventsByDateSuccess(true),
    [FETCH_EVENTS_BY_DATE_ERROR]: fetchEventsByDateSuccess(false),
    [RESET_FETCH_EVENTS_BY_DATE]: resetEventsByDate,
    [ADD_EVENT_TO_DUPLICATE]: addEventToDuplicate,
    [REMOVE_EVENT_TO_DUPLICATE]: removeEventToDuplicate,
    [ADD_EVENT_TO_EDIT]: addEventToEdit,
    [REMOVE_EVENT_TO_EDIT]: removeEventToEdit,
    [FETCH_RACE_EVENT_PROVIDERS_FETCHING]: raceEventProvidersFetching,
    [FETCH_RACE_EVENT_PROVIDERS_SUCCESS]: raceEventProvidersSuccess(true),
    [FETCH_RACE_EVENT_PROVIDERS_FAIL]: raceEventProvidersSuccess(true),
    [ADD_TEMPORARY_EVENT]: addTemporaryEvent,
    [REMOVE_TEMPORARY_EVENT]: removeTemporaryEvent,
    [RESET_SUBSCRIBER_EVENT_DETAILS]: resetSubcriberEventDetails
};

export default function shareableEvent(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];
    if (!handler) return state;
    return handler(state, action);
}

export const getSubscriberEventDetails = (state) => {
    return state.shareableEvent.eventDetails.event;
};

export const isSubscriberEventDetailsFetching = (state) => {
    return state.shareableEvent.fetching;
};

export const isSubscriberEventDetailsSuccess = (state) => {
    return state.shareableEvent.success;
};

export const isSubscriberEventDetailsError = (state) => {
    return state.event.error;
};

export const isEventsByDateFetching = (state) => {
    return state.shareableEvent.fetching;
};

export const isEventsByDateSuccess = (state) => {
    return state.shareableEvent.success;
};

export const getEventsByDate = (state) => {
    return state.shareableEvent.events;
};

export const getEventToCopy = (state) => {
    return state.shareableEvent.eventToCopy;
};

export const getEditEventInfo = (state) => {
    return state.shareableEvent.editEventInfo;
};

export const isRaceEventProvidersFetching = (state) => {
    return state.shareableEvent.raceEventProviders.fetching;
};

export const isRaceEventProvidersSuccess = (state) => {
    return state.shareableEvent.raceEventProviders.success;
};

export const isRaceEventProvidersError = (state) => {
    return state.shareableEvent.raceEventProviders.error;
};

export const getRaceEventProviders = (state) => {
    return state.shareableEvent.raceEventProviders.providers;
};

export const getTemporaryEvent = (state) => {
    return state.shareableEvent.temporaryEvent;
};
